var map = {
	"./Call.svg": 2292,
	"./CatRight.svg": 8726,
	"./Contact.svg": 1995,
	"./Copy.svg": 1235,
	"./CopyCheck.svg": 329,
	"./DogLeft.svg": 8585,
	"./Email.svg": 2396,
	"./Facebook.svg": 8552,
	"./Instagram.svg": 7584,
	"./Map.svg": 918,
	"./Pinterest.svg": 8634,
	"./Time.svg": 2143,
	"./Twitter.svg": 8889,
	"./Youtube.svg": 9839,
	"./allergy.svg": 9104,
	"./birthday.svg": 3727,
	"./bone.svg": 7782,
	"./calming.svg": 1579,
	"./dog.svg": 9450,
	"./dogLeg.svg": 2534,
	"./faq.svg": 9052,
	"./hip_joint.svg": 8134,
	"./home.svg": 3329,
	"./left-arrow.svg": 1435,
	"./left.svg": 9903,
	"./navigator.svg": 519,
	"./probiotics.svg": 4802,
	"./right-arrow.svg": 7134,
	"./right.svg": 2090,
	"./teeth.svg": 8190,
	"./word.svg": 7996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6047;